import { baseApi } from '@/lib/api/baseApi';
import { customersEndpoints } from './customers.queries';

export const customersApi = baseApi.injectEndpoints({ endpoints: customersEndpoints });

export const {
  useGetCustomersListQuery,
  useGetCustomerQuery,
  useCreateCustomerMutation,
  useUpdateCustomerMutation,
  useDeleteCustomerMutation,
  useGetCustomerSitesQuery,
  useGetCustomerSiteFormQuery,
  useCreateCustomerSitesMutation,
  useUpdateCustomerSiteMutation,
  useDeleteCustomerSiteMutation,
  useGetCustomerTransportationQuery,
  useCreateCustomerTransportationMutation,
  useUpdateCustomerTransportationMutation,
  useDeleteCustomerTransportationMutation,
} = customersApi;
